import React from 'react'
import SEO from '../common/SEO'
import ColorSwitcher from '../elements/switcher/ColorSwitcher'
import seoData from '../seoData/SearchEngineOptimization.json'
import CtaLayoutOne from '../component/cta/CtaLayoutOne'
import FooterOne from '../common/footer/FooterOne'
import HeaderOne from '../common/header/HeaderOne'
import SectionTitle from '../elements/section-title/SectionTitle'
import TestimonialPropTwo from '../component/testimonial/TestimonialPropTwo'
import TestimonialData from '../data/testimonial/TestimonialData.json'
import { slugify } from '../utils'
import BannerSearchEngineOptimization from '../component/banner/BannerSearchEngineOptimization'
import SEOBestForYouSection from '../component/features/SEOBestForYouSection'
import PSMFaqSection from '../component/features/PSMFaqSection'
import SEOFaqData from '../data/psm/SEOFaqData.json'
import SEOSwevicesShowcase from '../component/features/SEOSwevicesShowcase'
import PSMGrowSection from '../component/features/PSMGrowSection'
import SEOGrowData from '../data/psm/SEOGrowData.json';
import SEOAchievements from '../component/features/SEOAchievements'

const allData = TestimonialData;

const SearchEngineOptimization = () => {
    const facebookData = allData.filter(
        (data) => slugify(data.fromtext) === "facebook"
    );

    return (
        <>
            <SEO {...seoData} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />

                {/* Hero Banner Section */}
                <div className="section section-padding pb-0 ">
                    <BannerSearchEngineOptimization />
                </div>

                {/* Best For You Section */}
                <SEOBestForYouSection />

                {/* Interactive Services Showcase */}
                <SEOSwevicesShowcase />

                {/* Your Growth Our Priority Section */}
                {/* Your Growth Our Priority Section */}
                <PSMGrowSection
                    title="Why Choose Us"
                    subtitle="Your Growth Our Priority"
                    textAlignment="title heading-left"
                    textColor=""
                    paragraphClass="d-none"
                    data={SEOGrowData}
                    imgUrl={"/images/banner/SEO-grow.png"}
                />

                <SEOAchievements />

                {/* FAQ Section */}
                <PSMFaqSection faqData={SEOFaqData} />

                {/* Testimonials Section */}
                <div className="section section-padding customer-review-area overflow-hidden pb-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <SectionTitle
                                    subtitle=""
                                    title="Testimonials"
                                    textAlignment="heading-left"
                                    textColor=""
                                />
                            </div>
                            <div className="col-lg-4">
                                <div className="review-site-logo"></div>
                            </div>
                        </div>
                        <div className="row">
                            <TestimonialPropTwo
                                colSize="col-lg-3"
                                itemShow="5"
                                layoutStyle="testimonial-dark"
                                testimonialData={facebookData}
                            />
                        </div>
                    </div>
                    <ul className="shape-group-11 list-unstyled">
                        <li className="shape shape-1">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
                                alt="line"
                            />
                        </li>
                        <li className="shape shape-2">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                                alt="line"
                            />
                        </li>
                    </ul>
                </div>

                {/* Read Reviews Section */}
                {/* CTA and Footer */}
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main >
        </>
    )
}

export default SearchEngineOptimization